/**
 * "Esta conta acabou de nascer e ainda não decidiu a persona do bot."
 *
 * O backend não tem como responder isso: `GET /persona` nunca devolve
 * vazio — sem configuração salva ele devolve o default que o bot já usa, de
 * propósito. Ou seja, não existe do lado de lá a diferença entre "nunca
 * configurou" e "configurou igual ao default".
 *
 * E essa marca resolve outra coisa, independente disso: sem ela, o
 * `beforeLoad` do `_public` manda todo mundo autenticado para o painel
 * assim que o signup resolve, e a etapa da persona é atropelada antes de
 * aparecer — a navegação que vem depois do `await signup()` perde a corrida
 * para a invalidação do router.
 *
 * `sessionStorage` e não `localStorage` de propósito: isto vale para a aba
 * onde o cadastro aconteceu, não para sempre.
 */
const STORAGE_KEY = "agendo-certo:onboarding-pendente";

/** Chamado antes do signup, para valer mesmo se a navegação for atropelada. */
export function startOnboarding(vertical: string): void {
  sessionStorage.setItem(STORAGE_KEY, vertical);
}

/** O segmento escolhido no cadastro, ou `null` se não há onboarding pendente. */
export function pendingOnboarding(): string | null {
  return sessionStorage.getItem(STORAGE_KEY) || null;
}

/** Some com o pendente — tanto ao salvar quanto ao "deixar pra depois". */
export function finishOnboarding(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}
